module.exports = __webpack_public_path__ + "img/alfie-w2.60a3792a.png";